module.exports = (props) => [
	{
		titleText: 'Portal Configuration',
		key: 'Config',
		visible: false
	},
	{
		titleText: 'Port Safety Information',
		key: 'Safety',
		children: [
			{label: 'Medical Capability Reports', visible: true}
		],
	},

	{
		titleText: 'Personal Details',
		key: 'Personal',
		children: [
			{label: 'Basic Information', visible: true},
			{label: 'Emergency Contacts', visible: true},
			{label: 'SSN', visible: true},
			{label: 'Gender Identity', visible: true},
		],
	},
	{
		titleText: 'Admissions',
		key: 'Admissions',
		children: [
			{label: 'Basic Information', visible: props.isStudent === true},
			{label: 'Application Status', visible: props.isStudent === true},
			{label: 'Admit Status', visible: props.isStudent === true},
			{label: 'Ship Status', visible: props.isStudent === true},
			{label: 'Academic Action Plan', visible: props.isStudent === true && (props.academicActionStatus !== false)},
			{label: 'Signatory Statement', visible: props.isStudent === true }
		]
	},
	{
		titleText: 'School Information',
		key: 'School',
		children: [
			{label: 'Transcript Address', visible: true},
			{label: 'Invoice Address', visible: true},
			{label: 'Biography Note', visible: true, hideIf: () => props.canSeeBiography === false}
		]
	},
	{
		titleText: 'Travel Requirements',
			key: 'Travel',
			children: [
				{label: 'Passport Details', visible: true},
				{label: 'Visa Pre-Embarkation Form', visible: true},
				{label: 'Visa Instructions and Documents', visible: true},
				{label: 'Visa Status', visible: true}
			]
	},{
		titleText: 'Embarkation and Shuttles',
		key: 'Embarkation',
		visible: true
	},{
		titleText: 'Field Programs',
		key: 'Field',
		children: [
			{label: 'Registered', visible: true},
			// {
			// 	label: 'Global Studies Credit Eligible Field Programs',
			// 	visible: true,
			// 	requiredIf: () => props.GSCneeded && !props.GSCused,
			// 	blockIf: () => {
			// 		if (props.GSCused === true) return 'You have already used your Global Studies Credit';
			// 		return false;
			// 	},
			// 	hideIf: () => props.GSCneeded === false
			// },
			{label: 'Browse All', visible: true}
		],
		//status: () => (!props.bookingLoaded) ? '' : (!props.GSCneeded || props.GSCused)? 'done' : 'required',
	},{
		titleText: 'Payments and Financial Aid',
		key: 'Financial',
		children: [
			{label: 'Field Payment Status', visible: true},
			{label: 'Program Fee Payment Status', visible: true},
			{label: 'Financial Aid', visible: true},
			{label: 'Insurance Opt-out', visible: true},
			{label: 'Register Card', visible: true}
		]
	},{
		titleText: 'Academic Information',
		key: 'Academic',
		hideIf: () => props.isStudent === false,
		children: [
			{label: 'Basic Information', visible: true},
			{label: 'CSU EID', visible: true},
			{label: 'Updated Transcript Status', visible: true},
			// {label: 'Transcript Address', visible: true},
		]
	},
	{
		titleText: 'Health and Medical',
		key: 'Health',
		children: [
			{label: 'Medical History Form', visible: true},
			{label: 'Vaccinations', visible: true},
			{label: 'Allergies', visible: true},
			{label: 'Dietary Restrictions', visible: true},
			{label: 'Special Accomodations', visible: true},
			{label: 'Health Insurance Information', visible: true},
		]
	},{
		key: 'Agreements',
		status: () =>{ 
			if(!props.statusesLoaded) return '';
			if(props.isStudent && props.statuses.SRI_AGREE_TANDC &&
				props.statuses.SRI_AGREE_COFC &&
				props.statuses.SRI_AGREE_GR &&
				props.statuses.SRI_AGREE_CSU_TRAN &&
				props.statuses.SRI_AGREE_FERPA) {
					return 'done'
				}
			if(!props.isStudent && props.statuses.SRI_AGREE_TANDC &&
				props.statuses.SRI_AGREE_COFC &&
				props.statuses.SRI_AGREE_GR) {
					return 'done'
				}
				return 'required';
		},
		visible: true,
		titleText: 'Online Agreements',
	},{
		titleText: 'Cabin Information',
		key: 'Cabin',
		children: [
			{label: 'Cabin Type Preferences', visible: true},
			{label: 'Gender Inclusive Housing Options', visible: true},
			{label: 'Roommate Requests', visible: true}
		]
	}
];



// WEBPACK FOOTER //
// ./src/containers/Portal/menuItems.js